import { lazy } from "react";

const Template = lazy(() => import("../components/common/template/Index"));
const Help = lazy(() => import("../components/common/help/Index"));
const Video = lazy(() => import("../components/common/Video"));
const Report = lazy(() => import("../components/common/report/Index"));
const UserManagement = lazy(() => import("../components/common/UserManagement/Index"));
const ChangePassword = lazy(() => import("../components/common/ChangePassword"));
const MarketPlace = lazy(() => import("../components/common/MarketPlace"));
import { MODULE, SUBMODULE } from '../constants/user-management.constant';

const CommonRoutes = [
    { path: "/template", id: "TEMPLATE", moduleIds: [MODULE.ADMIN_TEMPLATES, MODULE.CLIENT_TEMPLATES], element: <Template />, base: '/template' },
    { path: "/help", id: 'HELP', moduleIds: [MODULE.ADMIN_HELP, MODULE.HELP], element: <Help />, base: '/help' },
    { path: '/video', id: 'VIDEO', moduleIds: [MODULE.ADMIN_HELP, MODULE.HELP], element: <Video />, base: '/video' },
    { path: '/report', moduleIds: [MODULE.ADMIN_REPORTS, MODULE.REPORTS,MODULE.PARTNER_REPORTS], id: "REPORT", element: <Report />, base: '/report' },
    { path: "/market-place", id: "CUSTOMER_MARKET_PLACE", moduleIds: [MODULE.ADMIN_MARKETPALCE, MODULE.MARKET_PLACE], element: <MarketPlace />, base: '/market-place' },
    { path: '/user-management/:tab?/:action?/:id?', moduleIds: [MODULE.ADMIN_USER_MANAGEMENT, MODULE.USER_MANAGEMENT], id: "USER_MANAGEMENT", element: <UserManagement />, base: '/user-management' },
    { path: '/change-password', id: 'CHANGE_PASSWORD', moduleIds: [MODULE.CHANGEPASSWORD], subModuleIds: [SUBMODULE.CLIENT_CHANGE_PASSWORD], element: <ChangePassword />, base: '/change-password' },
];

export default CommonRoutes;